import { render, staticRenderFns } from "./ListPlanos.vue?vue&type=template&id=5a044495&"
import script from "./ListPlanos.vue?vue&type=script&lang=js&"
export * from "./ListPlanos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports